
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("9KmoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1888dab402a1b43d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jbPE2 = parcelRequire("jbPE2");

var $3Ju8W = parcelRequire("3Ju8W");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");

var $gZTP9 = parcelRequire("gZTP9");

var $lvKO5 = parcelRequire("lvKO5");

var $90zjX = parcelRequire("90zjX");

var $jaf8h = parcelRequire("jaf8h");

var $dxgbR = parcelRequire("dxgbR");

var $cP2BX = parcelRequire("cP2BX");
const $1888dab402a1b43d$var$ActionsMenuComponent = ({ issueKey: issueKey, issueId: issueId, environment: environment, cloudId: cloudId, projectType: projectType, transitions: transitions, onTransitionStatus: onTransitionStatus, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1888dab402a1b43d$var$actionsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ju8W.ManualRulesContainer), {
        env: environment,
        cloudId: cloudId,
        issueIds: issueId ? [
            Number(issueId)
        ] : []
    }, ({ triggerFetch: triggerFetch, initialised: initialised, rules: rules, invokingRuleId: invokingRuleId, invokeRuleOrShowDialog: invokeRuleOrShowDialog })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cP2BX.ActionsMenu), {
            issueKey: issueKey,
            issueId: Number(issueId),
            projectType: projectType,
            rules: rules,
            triggerFetch: triggerFetch,
            executeRule: invokeRuleOrShowDialog,
            executingRule: invokingRuleId,
            initialised: initialised,
            transitions: transitions,
            onSelect: onTransitionStatus,
            canManageAutomations: canManageAutomations,
            baseAutomationUrl: baseAutomationUrl
        })));
const $1888dab402a1b43d$var$ActionsNew = ({ initialStatusValue: initialStatusValue, onSubmit: onSubmit, onSuccess: onSuccess })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const issueId = (0, $bmoS1.useIssueId)();
    const baseUrl = '';
    const projectKey = (0, $bmoS1.useProjectKey)();
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const isSimplified = (0, $bNexr.useIsSimplifiedProject)(projectKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const baseAutomationUrl = (0, $eJOHy.useMemo)(()=>(0, $jbPE2.getBaseAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplified
        }), [
        projectKey,
        projectType,
        isSimplified
    ]);
    const isProjectAdmin = (0, $f5OzW.useCanAdministerProject)(projectKey);
    const isGlobalAdmin = (0, $gZTP9.useIsAdmin)();
    const canManageAutomations = isProjectAdmin || isGlobalAdmin;
    const { environment: environment, cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaf8h.StatusService), {
        appearance: "button",
        projectType: projectType || null,
        issueKey: issueKey,
        issueId: issueId,
        baseUrl: baseUrl,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        initialValue: initialStatusValue
    }, ({ value: statusServiceValue, loading: saving, transitionStatus: transitionStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxgbR.TransitionsQuery), {
            issueKey: issueKey,
            baseUrl: baseUrl,
            status: statusServiceValue,
            isSaving: saving,
            preFetch: true,
            projectType: projectType
        }, ({ data: transitions })=>{
            const loopedTransitions = (0, $90zjX.getLoopedTransitionsForStatus)(transitions, statusServiceValue.id);
            const menuProps = {
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                projectType: projectType,
                issueKey: issueKey,
                issueId: issueId,
                transitions: loopedTransitions,
                onTransitionStatus: transitionStatus,
                baseAutomationUrl: baseAutomationUrl,
                canManageAutomations: canManageAutomations
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1888dab402a1b43d$var$ActionsMenuComponent, menuProps);
        }));
};
const $1888dab402a1b43d$var$actionsWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
var $1888dab402a1b43d$export$2e2bcd8739ae039 = $1888dab402a1b43d$var$ActionsNew;

});
parcelRegister("jbPE2", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $192a6ea715d806e4$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $192a6ea715d806e4$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $192a6ea715d806e4$export$8e479e490e1e69bc);

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $192a6ea715d806e4$var$localStorage = (0, $dnU6V.createLocalStorageProvider)('automation-menu');
const $192a6ea715d806e4$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $192a6ea715d806e4$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $7jTnu.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $192a6ea715d806e4$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $192a6ea715d806e4$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $192a6ea715d806e4$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $192a6ea715d806e4$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $192a6ea715d806e4$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $192a6ea715d806e4$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $7jTnu.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});

parcelRegister("3Ju8W", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $fc182a2668488557$export$eb0a81e78d942dba);

var $eJOHy = parcelRequire("eJOHy");

var $jOYI6 = parcelRequire("jOYI6");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $8oKDI = parcelRequire("8oKDI");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $20L8H = parcelRequire("20L8H");
const $fc182a2668488557$export$eb0a81e78d942dba = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { env: env, cloudId: cloudId, issueIds: issueIds } = props;
    let automationEnv = env;
    if (env === 'prod') automationEnv = (0, $7jTnu.fg)('automation-dev-helper') ? 'pre-prod' : 'prod';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jOYI6.ManualRulesContainer), {
        site: (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        }),
        query: {
            objects: issueIds?.map((id)=>(0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'issue',
                    cloudId: cloudId,
                    resourceId: id.toString()
                }))
        },
        env: automationEnv,
        onInputsModalOpened: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRuleModal',
                action: 'opened'
            });
            const attributes = {
                objectType: 'issue'
            };
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationLifecycleStarted: (_, __, userInputs)=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRule',
                action: 'tryInvoke'
            });
            const attributes = {
                objectType: 'issue',
                ruleHasInputs: Boolean(userInputs),
                objectsSelected: issueIds.length
            };
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationSuccess: ()=>showFlag({
                type: 'info',
                title: formatMessage((0, $20L8H.default).successFlag),
                isAutoDismiss: true,
                messageId: 'automation-platform.ui.manual-rules-container.show-flag.info.success-flag',
                messageType: 'transactional'
            }),
        onRuleInvocationFailure: ()=>showFlag({
                type: 'error',
                title: formatMessage((0, $20L8H.default).failureFlagTitle),
                description: formatMessage((0, $20L8H.default).failureFlagDescription),
                isAutoDismiss: true,
                messageId: 'automation-platform.ui.manual-rules-container.show-flag.error.failure-flag',
                messageType: 'transactional'
            })
    }, props.children);
};

});
parcelRegister("jOYI6", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $b1783e5d883a67df$export$eb0a81e78d942dba);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $956it = parcelRequire("956it");

var $bCggn = parcelRequire("bCggn");

var $fCuEG = parcelRequire("fCuEG");
const $b1783e5d883a67df$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [rules, setRules] = (0, $eJOHy.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $bCggn.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $b1783e5d883a67df$export$eb0a81e78d942dba = (props)=>{
    (0, $gRw8I.di)((0, $956it.default), (0, $fCuEG.default), (0, $bCggn.invokeManuallyTriggeredRule), $b1783e5d883a67df$export$96513fc6544cb4e5, (0, $eJOHy.useMemo), (0, $eJOHy.useState));
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $b1783e5d883a67df$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $eJOHy.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $eJOHy.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $eJOHy.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>rule?.userInputPrompts?.length > 0;
    const INVOCATIONS = 'invocations';
    const SUCCESS = 'SUCCESS';
    const getFailedObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] !== SUCCESS);
    const getSuccessfulObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] === SUCCESS);
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $bCggn.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children({
                triggerFetch: triggerFetch,
                initialised: initialised,
                error: error,
                rules: rules,
                invokingRuleId: invokingRuleId,
                invokeRuleOrShowDialog: invokeRuleOrShowDialog
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
                children: selectedRule && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fCuEG.default), {
                    onInputsModalOpened: onInputsModalOpened,
                    onInputsModalClosed: onInputsModalClosed,
                    clearSelectedRule: clearSelectedRule,
                    selectedRule: selectedRule,
                    invokeRule: invokeRule
                })
            })
        ]
    });
};

});
parcelRegister("bCggn", function(module, exports) {

$parcel$export(module.exports, "searchManuallyTriggeredRules", () => $fd6de5a96461c63b$export$11e317ae81dd4223);
$parcel$export(module.exports, "invokeManuallyTriggeredRule", () => $fd6de5a96461c63b$export$9a0eb4136c6b46c);

var $mza2d = parcelRequire("mza2d");
const $fd6de5a96461c63b$export$11e317ae81dd4223 = async (env, site, query)=>{
    const url = await (0, $mza2d.getSearchUrl)(env, site);
    // TODO this will in the new API be a GET request instead, with the above getSearchUrl method
    // constructing a URL with the appropriate query parameters. For now, instead, we pass the
    // destructured query through as a POST body.
    const response = await (0, $mza2d.performPostRequest)(url, {
        body: JSON.stringify(query)
    });
    return response.reduce((acc, { id: id, name: name, ruleScope: ruleScope, userInputs: userInputs })=>({
            // eslint-disable-next-line
            ...acc,
            [id]: {
                id: id,
                name: name,
                ruleScope: ruleScope,
                userInputPrompts: userInputs
            }
        }), {});
};
const $fd6de5a96461c63b$export$9a0eb4136c6b46c = async (env, site, ruleId, objects, userInputs)=>{
    const url = await (0, $mza2d.getInvocationUrl)(env, site, ruleId);
    const bodyRaw = {
        objects: objects
    };
    if (userInputs) bodyRaw.userInputs = userInputs;
    return (0, $mza2d.performPostRequest)(url, {
        body: JSON.stringify(bodyRaw)
    });
};

});
parcelRegister("mza2d", function(module, exports) {

$parcel$export(module.exports, "getSearchUrl", () => $6c8e8834bf8c39d2$export$7d4675b206f57488);
$parcel$export(module.exports, "getInvocationUrl", () => $6c8e8834bf8c39d2$export$e62dcf5e32cec4bf);
$parcel$export(module.exports, "performPostRequest", () => $6c8e8834bf8c39d2$export$692a4d9808143175);

var $eGOwo = parcelRequire("eGOwo");

var $63yBZ = parcelRequire("63yBZ");

var $j7Xtp = parcelRequire("j7Xtp");
const $6c8e8834bf8c39d2$export$1cb1c6bd5a8f1613 = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $63yBZ.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = 'jira';
    } catch (error) {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site' || cloudId === undefined) throw new Error('Not a site ARI: ' + site);
    return {
        product: resourceOwner,
        cloudId: cloudId
    };
};
const $6c8e8834bf8c39d2$export$7d4675b206f57488 = async (env, site)=>{
    const { product: product, cloudId: cloudId } = $6c8e8834bf8c39d2$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $j7Xtp.getAutomationStack)(env, cloudId);
    // TODO in the unified API, GET requests as according to Atlassian API standards will destructure the whole query into
    // query parameters as part of the URL. For now, this is considered a POST request instead and thus the query is used
    // later on as the request body.
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/search`;
};
const $6c8e8834bf8c39d2$export$e62dcf5e32cec4bf = async (env, site, ruleId)=>{
    const { product: product, cloudId: cloudId } = $6c8e8834bf8c39d2$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $j7Xtp.getAutomationStack)(env, cloudId);
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/invocation/${ruleId}`;
};
const $6c8e8834bf8c39d2$var$DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
const $6c8e8834bf8c39d2$var$_performRequest = async (url, method, options = {
    headers: $6c8e8834bf8c39d2$var$DEFAULT_HEADER
})=>{
    const response = await fetch(url, {
        ...options,
        method: method
    });
    return response.json();
};
const $6c8e8834bf8c39d2$export$4a53ae1be8ec80c7 = async (url, options)=>{
    return $6c8e8834bf8c39d2$var$_performRequest(url, 'GET', options);
};
const $6c8e8834bf8c39d2$export$692a4d9808143175 = async (url, options)=>{
    return $6c8e8834bf8c39d2$var$_performRequest(url, 'POST', options);
};
const $6c8e8834bf8c39d2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'customer_service' && (0, $eGOwo.fg)('jcs_project_type_m3')) return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});
parcelRegister("63yBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $ik6eF = parcelRequire("ik6eF");

$dnskZ.__exportStar((parcelRequire("jWqQq")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $468ddf0950beb311$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $468ddf0950beb311$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $468ddf0950beb311$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $468ddf0950beb311$var$InvalidAriError;
function $468ddf0950beb311$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $468ddf0950beb311$var$basicCharConstraint = $ik6eF.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $468ddf0950beb311$var$resourceTypeCharConstraints = $ik6eF.pattern(/^[a-z][a-z.-]*$/i);
const $468ddf0950beb311$var$resourceOwnerConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$basicCharConstraint
];
const $468ddf0950beb311$var$resourceTypeConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$resourceTypeCharConstraints
];
const $468ddf0950beb311$var$cloudIdConstraints = [
    $ik6eF.lengthBetween(3, 255)
];
const $468ddf0950beb311$var$siteResourceType = 'site';
const $468ddf0950beb311$var$resourceIdChars = /[\w-._~:@#]/.source;
const $468ddf0950beb311$var$resourceIdConstraints = [
    $ik6eF.pattern(new RegExp(`^${$468ddf0950beb311$var$resourceIdChars}+(/${$468ddf0950beb311$var$resourceIdChars}*)*(;v=${$468ddf0950beb311$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $468ddf0950beb311$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $468ddf0950beb311$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $468ddf0950beb311$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $468ddf0950beb311$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $468ddf0950beb311$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        return new $468ddf0950beb311$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $468ddf0950beb311$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $468ddf0950beb311$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $468ddf0950beb311$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $468ddf0950beb311$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $468ddf0950beb311$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $468ddf0950beb311$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $468ddf0950beb311$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $468ddf0950beb311$var$siteResourceType && !cloudId) return new $ik6eF.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'resourceOwner', $468ddf0950beb311$var$resourceOwnerConstraints),
            $ik6eF.validateField(this, 'resourceType', $468ddf0950beb311$var$resourceTypeConstraints),
            $ik6eF.validateField(this, 'resourceId', $468ddf0950beb311$var$resourceIdConstraints),
            $ik6eF.validateField(this, 'cloudId', $468ddf0950beb311$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $468ddf0950beb311$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $468ddf0950beb311$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $468ddf0950beb311$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parse(ariString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $468ddf0950beb311$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parseEncoded(encodedAriString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $468ddf0950beb311$var$parseEncoded;

});
parcelRegister("ik6eF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eDoz3 = parcelRequire("eDoz3");
class $d56eee7d06fcc64a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $d56eee7d06fcc64a$var$LengthConstraint;
class $d56eee7d06fcc64a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $d56eee7d06fcc64a$var$RegexConstraint;
class $d56eee7d06fcc64a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $d56eee7d06fcc64a$var$GeneralValidationError;
class $d56eee7d06fcc64a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $d56eee7d06fcc64a$var$ConstraintViolation;
function $d56eee7d06fcc64a$var$lengthBetween(min, max) {
    return new $d56eee7d06fcc64a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $d56eee7d06fcc64a$var$lengthBetween;
function $d56eee7d06fcc64a$var$pattern(regex) {
    return new $d56eee7d06fcc64a$var$RegexConstraint(regex);
}
module.exports.pattern = $d56eee7d06fcc64a$var$pattern;
function $d56eee7d06fcc64a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($eDoz3.isDefined);
    return violatedConstraints.length > 0 ? new $d56eee7d06fcc64a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $d56eee7d06fcc64a$var$validateField;

});
parcelRegister("eDoz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $aa77c3314e9d9437$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $aa77c3314e9d9437$var$isPresent;
function $aa77c3314e9d9437$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $aa77c3314e9d9437$var$isDefined;
function $aa77c3314e9d9437$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $aa77c3314e9d9437$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $aa77c3314e9d9437$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $aa77c3314e9d9437$var$hasValueAtKey;

});


parcelRegister("jWqQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZFVe = parcelRequire("4ZFVe");
var $e84841da69f5e74e$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($e84841da69f5e74e$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $e84841da69f5e74e$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $e84841da69f5e74e$var$AppFamilyAriError;
class $e84841da69f5e74e$var$NotAppFamilyAriError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $e84841da69f5e74e$var$NotAppFamilyAriError;
class $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $e84841da69f5e74e$var$parseAppAri(ari) {
    return $4ZFVe.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $e84841da69f5e74e$var$parseAppAri;
function $e84841da69f5e74e$var$createAppAri(json) {
    return new $4ZFVe.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $e84841da69f5e74e$var$createAppAri;

});
parcelRegister("4ZFVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jWqQq = parcelRequire("jWqQq");

var $63yBZ = parcelRequire("63yBZ");

var $ik6eF = parcelRequire("ik6eF");
const $3a2d60ca363a4626$var$versionPrefix = ';v=';
const $3a2d60ca363a4626$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $3a2d60ca363a4626$var$uuidConstraints = [
    $ik6eF.pattern(new RegExp(`^${$3a2d60ca363a4626$var$uuidRegExpString}$`, 'i'))
];
const $3a2d60ca363a4626$var$extensionGroupIdConstraints = [
    $ik6eF.pattern(new RegExp(`^(${$3a2d60ca363a4626$var$uuidRegExpString}|static)$`, 'i'))
];
class $3a2d60ca363a4626$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $jWqQq.AppFamilyAri.resourceOwner) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$jWqQq.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $jWqQq.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceType must be one of ${$jWqQq.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $jWqQq.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($3a2d60ca363a4626$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($3a2d60ca363a4626$var$versionPrefix) > versionIndex) throw new $jWqQq.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($3a2d60ca363a4626$var$versionPrefix);
        const segments = mainResourceId.split('/').map($3a2d60ca363a4626$var$stripToUndefined);
        if (segments.length > 4) throw new $jWqQq.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $jWqQq.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType || resourceType === $jWqQq.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $jWqQq.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        return new $3a2d60ca363a4626$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $jWqQq.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'environmentId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'appId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'extensionGroupId', $3a2d60ca363a4626$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $63yBZ.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $jWqQq.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$3a2d60ca363a4626$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $3a2d60ca363a4626$var$AppFamilyAriImpl;
function $3a2d60ca363a4626$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("j7Xtp", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $7686716512bb4887$export$6123178d3f5fb24d);
const $7686716512bb4887$var$AUTOMATION_LOCAL_STORAGE_PREFIX = 'automationPlatform';
const $7686716512bb4887$var$AUTOMATION_LOCAL_STORAGE_STACK = 'automationStack';
const $7686716512bb4887$var$AUTOMATION_DEV_STACK_URL = 'https://localhost:8082/devStack.json';
const $7686716512bb4887$var$getAutomationProdStackUrl = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $7686716512bb4887$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($7686716512bb4887$var$getAutomationProdStackUrl(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$7686716512bb4887$var$getAutomationProdStackUrl(cloudId)} with error: ${e}`);
        return null;
    }
};
const $7686716512bb4887$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$7686716512bb4887$var$AUTOMATION_LOCAL_STORAGE_PREFIX}:${key}`);
};
const $7686716512bb4887$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($7686716512bb4887$var$AUTOMATION_DEV_STACK_URL);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$7686716512bb4887$var$AUTOMATION_DEV_STACK_URL} with error: ${e}`);
        return null;
    }
};
const $7686716512bb4887$export$48cdb3ba720a47f6 = ()=>$7686716512bb4887$var$_getAutomationKeyFromLocalStorage($7686716512bb4887$var$AUTOMATION_LOCAL_STORAGE_STACK);
const $7686716512bb4887$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') return 'pro';
    if (env === 'pre-prod') {
        const stack = await $7686716512bb4887$var$getLatestPreProdStack(cloudId);
        return stack ?? 'pro';
    }
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $7686716512bb4887$var$getAutomationDevStackFromLocalServer() || $7686716512bb4887$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};

});



parcelRegister("fCuEG", function(module, exports) {

$parcel$export(module.exports, "UserInputForm", () => $4a6aa070ade92dca$export$a3f697c029ab2691);
$parcel$export(module.exports, "default", () => $4a6aa070ade92dca$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $fKXve = parcelRequire("fKXve");
var $bUGwX = parcelRequire("bUGwX");

var $fmSFT = parcelRequire("fmSFT");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $eGOwo = parcelRequire("eGOwo");

var $58D9f = parcelRequire("58D9f");

var $dz5Na = parcelRequire("dz5Na");

var $JnmRN = parcelRequire("JnmRN");

var $4fBlA = parcelRequire("4fBlA");

var $57r61 = parcelRequire("57r61");

var $K1X0Q = parcelRequire("K1X0Q");

var $1evcu = parcelRequire("1evcu");
const $4a6aa070ade92dca$export$a3f697c029ab2691 = (props)=>{
    (0, $gRw8I.di)((0, $JnmRN.default), (0, $5CSKW.default), (0, $fKXve.ErrorMessage), (0, $3L3Os.default), (0, $bUGwX.default), (0, $fmSFT.default), (0, $ik0CA.default), (0, $kseeK.default), (0, $2qG7I.default), (0, $5a9Ro.default), (0, $4fBlA.default), (0, $K1X0Q.default), (0, $1evcu.default));
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>prompts.find(({ variableName: variableName })=>variableName === key)?.inputType;
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $dz5Na.UserInputType).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $dz5Na.UserInputType).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $dz5Na.UserInputType).TEXT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1evcu.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $dz5Na.UserInputType).NUMBER:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fBlA.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $dz5Na.UserInputType).DROPDOWN:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $K1X0Q.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $dz5Na.UserInputType).BOOLEAN:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JnmRN.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $dz5Na.UserInputType).PARAGRAPH:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $57r61.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            default:
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                            children: (0, $58D9f.default).errorInputTypeIsNotSupported.defaultMessage
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fmSFT.default), {
        "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
        onClose: handleClose,
        onOpenComplete: handleOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
            onSubmit: handleSubmit,
            children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                            ...(0, $eGOwo.fg)('ux-3549-automation-api-fix-modal-close-buttons') ? {
                                hasCloseButton: true
                            } : {},
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                                children: rule.name
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                            children: [
                                (0, $58D9f.default).inputRequiredForAction.defaultMessage,
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bUGwX.default), {
                                    children: userInputPrompts.map(generateUserInputForm)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                    appearance: "subtle",
                                    onClick: handleClose,
                                    isDisabled: submitting,
                                    children: (0, $58D9f.default).cancelButtonTitle.defaultMessage
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isLoading: submitting,
                                    autoFocus: true,
                                    children: (0, $58D9f.default).continueButtonTitle.defaultMessage
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
var $4a6aa070ade92dca$export$2e2bcd8739ae039 = $4a6aa070ade92dca$export$a3f697c029ab2691;

});
parcelRegister("bUGwX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc3e6ec1cedfa1c$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $4dc3e6ec1cedfa1c$var$formSectionDescriptionStyles = null;
const $4dc3e6ec1cedfa1c$var$formSectionWrapperStyles = null;
const $4dc3e6ec1cedfa1c$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $4dc3e6ec1cedfa1c$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $4dc3e6ec1cedfa1c$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)($4dc3e6ec1cedfa1c$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)($4dc3e6ec1cedfa1c$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $4dc3e6ec1cedfa1c$export$2e2bcd8739ae039 = $4dc3e6ec1cedfa1c$var$FormSection;

});

parcelRegister("58D9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $25288d084706bba2$export$2e2bcd8739ae039);
const $25288d084706bba2$var$messages = {
    successFlag: {
        id: 'automation-platform.common.success-flag',
        defaultMessage: 'Your automation is in progress',
        description: 'Text for a success flag when an automation rule has been triggered'
    },
    failureFlagTitle: {
        id: 'automation-platform.common.failure-flag-title',
        defaultMessage: 'Oops we ran into a problem',
        description: 'Title for an error flag when an automation rule failed to be triggered'
    },
    failureFlagDescription: {
        id: 'automation-platform.common.failure-flag-description',
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
        description: 'Description for an error flag when an automation rule failed to be triggered'
    },
    partialFailureFlagDescription: {
        id: 'automation-platform.common.partial-failure-flag-description',
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
        description: 'Description for an error flag when some issues failed to invoke because user does not have view permission'
    },
    errorInputMustNotBeEmpty: {
        id: 'automation-platform.common.error-input-must-not-be-empty',
        defaultMessage: 'Input must not be empty',
        description: 'The error message to show the value of a required field is empty'
    },
    errorInputCharacterLimitReached: {
        id: 'automation-platform.common.error-input-character-limit-reached',
        defaultMessage: 'Provided value exceeds the character limit for the field.',
        description: 'The error message to show that the character limit has been reached for the field'
    },
    inputRequiredForAction: {
        id: 'automation-platform.common.input-required-for-action',
        defaultMessage: 'Your input is required to complete this action',
        description: 'The title of the modal for user inputs'
    },
    errorInputTypeIsNotSupported: {
        id: 'automation-platform.common.error-input-type-is-not-supported',
        defaultMessage: 'Input type not supported yet',
        description: 'The error message to show when the type of user input is not recognised'
    },
    errorValueIsNotValidNumber: {
        id: 'automation-platform.common.error-value-is-not-valid-number',
        defaultMessage: 'The value is not a valid number',
        description: 'The error message for when the type of user input is number but the value is not a valid number'
    },
    cancelButtonTitle: {
        id: 'automation-platform.common.cancel-button-title',
        defaultMessage: 'Cancel',
        description: 'The cancel button title'
    },
    continueButtonTitle: {
        id: 'automation-platform.common.continue-button-title',
        defaultMessage: 'Continue',
        description: 'The continue button title'
    }
};
var $25288d084706bba2$export$2e2bcd8739ae039 = $25288d084706bba2$var$messages;

});

parcelRegister("dz5Na", function(module, exports) {

$parcel$export(module.exports, "UserInputType", () => $4cef0cec41380d59$export$955ccc93b55d5904);
var $4cef0cec41380d59$export$955ccc93b55d5904 = /*#__PURE__*/ function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
    return UserInputType;
}({});
const $4cef0cec41380d59$export$4b79f735ed858abe = 'business';
const $4cef0cec41380d59$export$417275bac62d38d2 = 'software';
const $4cef0cec41380d59$export$9c9c9eaf8c092006 = 'service_desk';
const $4cef0cec41380d59$export$e9fe9a39cc7f5103 = 'product_discovery';
const $4cef0cec41380d59$export$e9c56aa3b027d98f = 'customer_service';

});

parcelRegister("JnmRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $193f3a50ec501110$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $86tBw = parcelRequire("86tBw");

var $2yMqp = parcelRequire("2yMqp");
const $193f3a50ec501110$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gRw8I.di)((0, $86tBw.default), (0, $2yMqp.default));
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2yMqp.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
                ...fieldProps,
                label: displayName
            })
    });
};
var $193f3a50ec501110$export$2e2bcd8739ae039 = $193f3a50ec501110$var$BooleanInputPrompt;

});
parcelRegister("2yMqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $636b62edc5d062fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $636b62edc5d062fa$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $eJOHy.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
$636b62edc5d062fa$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $636b62edc5d062fa$export$2e2bcd8739ae039 = $636b62edc5d062fa$var$CheckboxField;

});


parcelRegister("4fBlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2392d771d3976c85$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $sY9BV = parcelRequire("sY9BV");

var $58D9f = parcelRequire("58D9f");
var $2392d771d3976c85$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return Errors;
}({});
const $2392d771d3976c85$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $2392d771d3976c85$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gRw8I.di)((0, $fKXve.ErrorMessage), (0, $6svxr.default), (0, $sY9BV.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                    children: (0, $58D9f.default).errorInputMustNotBeEmpty.defaultMessage
                });
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                    children: (0, $58D9f.default).errorValueIsNotValidNumber.defaultMessage
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$2392d771d3976c85$export$c6cbc3bbef9e5a54(required, value),
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sY9BV.default), {
                        ...fieldProps
                    }),
                    generateErrorMessage(error)
                ]
            })
    }, variableName);
};
var $2392d771d3976c85$export$2e2bcd8739ae039 = $2392d771d3976c85$var$NumberInputPrompt;

});

parcelRegister("57r61", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccb8202d5bbd47e9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $dQmi3 = parcelRequire("dQmi3");

var $58D9f = parcelRequire("58D9f");
var $ccb8202d5bbd47e9$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
    return Errors;
}($ccb8202d5bbd47e9$var$Errors || {});
const $ccb8202d5bbd47e9$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $ccb8202d5bbd47e9$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gRw8I.di)((0, $fKXve.ErrorMessage), (0, $6svxr.default), (0, $dQmi3.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        if (value && value?.trim().length === 0) return "EMPTY";
        if (value && value.length > $ccb8202d5bbd47e9$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return "CHARACTER_LIMIT";
        return undefined;
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQmi3.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                        children: (0, $58D9f.default).errorInputMustNotBeEmpty.defaultMessage
                    }),
                    error === "CHARACTER_LIMIT" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                        children: (0, $58D9f.default).errorInputCharacterLimitReached.defaultMessage
                    })
                ]
            })
    });
};
var $ccb8202d5bbd47e9$export$2e2bcd8739ae039 = $ccb8202d5bbd47e9$var$ParagraphInputPrompt;

});
parcelRegister("dQmi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef995104f62942f4$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $eGOwo = parcelRequire("eGOwo");
const $ef995104f62942f4$var$packageName = "platform-pkg";
const $ef995104f62942f4$var$packageVersion = "0.0.0-use.local";
const $ef995104f62942f4$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $ef995104f62942f4$var$packageName,
    packageVersion: $ef995104f62942f4$var$packageVersion
};
const $ef995104f62942f4$var$lineHeightBase = 20;
const $ef995104f62942f4$var$lineHeightCompact = 16;
const $ef995104f62942f4$var$compactVerticalPadding = 2;
const $ef995104f62942f4$var$verticalPadding = 6;
const $ef995104f62942f4$var$transitionDuration = '0.2s';
const $ef995104f62942f4$var$borderWidth = 2;
const $ef995104f62942f4$var$baseStyles = null;
const $ef995104f62942f4$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $ef995104f62942f4$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $ef995104f62942f4$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $ef995104f62942f4$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $ef995104f62942f4$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $ef995104f62942f4$var$InnerTextArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const ourRef = (0, $eJOHy.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $eJOHy.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eJOHy.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $ef995104f62942f4$var$appearanceStyles[appearance],
            (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && $ef995104f62942f4$var$fontStyles['large'],
            $ef995104f62942f4$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $ef995104f62942f4$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightCompact * minimumRows + $ef995104f62942f4$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightBase * minimumRows + $ef995104f62942f4$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $ef995104f62942f4$var$TextArea = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ef995104f62942f4$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$ef995104f62942f4$var$TextArea.displayName = 'TextArea';
var $ef995104f62942f4$export$2e2bcd8739ae039 = $ef995104f62942f4$var$TextArea;

});


parcelRegister("K1X0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd3817c025c932f0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $c4OV1 = parcelRequire("c4OV1");

var $58D9f = parcelRequire("58D9f");
var $dd3817c025c932f0$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($dd3817c025c932f0$var$Errors || {});
const $dd3817c025c932f0$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gRw8I.di)((0, $fKXve.ErrorMessage), (0, $6svxr.default), (0, $c4OV1.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                        isClearable: true,
                        isSearchable: true,
                        options: selectOptions,
                        menuPosition: "fixed",
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                        children: (0, $58D9f.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $dd3817c025c932f0$export$2e2bcd8739ae039 = $dd3817c025c932f0$var$SelectInputPrompt;

});

parcelRegister("1evcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $dabab3ee106a223b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $sY9BV = parcelRequire("sY9BV");

var $58D9f = parcelRequire("58D9f");
var $dabab3ee106a223b$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($dabab3ee106a223b$var$Errors || {});
const $dabab3ee106a223b$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gRw8I.di)((0, $fKXve.ErrorMessage), (0, $6svxr.default), (0, $sY9BV.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sY9BV.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                        children: (0, $58D9f.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $dabab3ee106a223b$export$2e2bcd8739ae039 = $dabab3ee106a223b$var$TextInputPrompt;

});



parcelRegister("20L8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $74a53fa6a2da5e4c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $74a53fa6a2da5e4c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    successFlag: {
        "id": "automation-platform.common.success-flag",
        "defaultMessage": "Your automation is in progress"
    },
    failureFlagTitle: {
        "id": "automation-platform.common.failure-flag-title",
        "defaultMessage": "Oops we ran into a problem"
    },
    failureFlagDescription: {
        "id": "automation-platform.common.failure-flag-description",
        "defaultMessage": "There was a problem and we couldn't run the automation \"{0}\""
    },
    partialFailureFlagDescription: {
        "id": "automation-platform.common.partial-failure-flag-description",
        "defaultMessage": "Couldn't run the automation against issues \"{0}\", please ensure you have permission to view these issues"
    },
    errorInputMustNotBeEmpty: {
        "id": "automation-platform.common.error-input-must-not-be-empty",
        "defaultMessage": "Input must not be empty"
    },
    errorInputCharacterLimitReached: {
        "id": "automation-platform.common.error-input-character-limit-reached",
        "defaultMessage": "Provided value exceeds the character limit for the field."
    },
    inputRequiredForAction: {
        "id": "automation-platform.common.input-required-for-action",
        "defaultMessage": "Your input is required to complete this action"
    },
    errorInputTypeIsNotSupported: {
        "id": "automation-platform.common.error-input-type-is-not-supported",
        "defaultMessage": "Input type not supported yet"
    },
    errorValueIsNotValidNumber: {
        "id": "automation-platform.common.error-value-is-not-valid-number",
        "defaultMessage": "The value is not a valid number"
    },
    cancelButtonTitle: {
        "id": "automation-platform.common.cancel-button-title",
        "defaultMessage": "Cancel"
    },
    continueButtonTitle: {
        "id": "automation-platform.common.continue-button-title",
        "defaultMessage": "Continue"
    }
});

});


parcelRegister("cP2BX", function(module, exports) {

$parcel$export(module.exports, "ActionsMenu", () => $bf7b55c097e2a19e$export$dcd7272559c21ebc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $fL0In = parcelRequire("fL0In");

var $dtpha = parcelRequire("dtpha");

var $5lAAn = parcelRequire("5lAAn");

var $cNe2t = parcelRequire("cNe2t");

var $c3rOS = parcelRequire("c3rOS");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $dPMMf = parcelRequire("dPMMf");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $bbdV2 = parcelRequire("bbdV2");

var $6pncb = parcelRequire("6pncb");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $jGBZo = parcelRequire("jGBZo");

var $9T6V5 = parcelRequire("9T6V5");

var $4mfgo = parcelRequire("4mfgo");
const $bf7b55c097e2a19e$var$tooltipOptions = {
    position: 'top',
    hideTooltipOnClick: true
};
const $bf7b55c097e2a19e$var$customModifiers = [
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: {
                top: 65
            }
        }
    }
];
const $bf7b55c097e2a19e$var$RecurWorkItemContainerEmpty = ({ children: children })=>children;
const $bf7b55c097e2a19e$var$entryPointParams = {};
const $bf7b55c097e2a19e$export$f48224de87d33a65 = ()=>(0, $eJOHy.useState)(false);
const $bf7b55c097e2a19e$export$dcd7272559c21ebc = (props)=>{
    const { transitions: transitions, onSelect: onSelect, rules: rules, executeRule: executeRule, executingRule: executingRule, triggerFetch: triggerFetch, initialised: initialised, issueKey: issueKey, issueId: issueId, projectType: projectType, baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations } = props;
    const [activePopupKey, setActivePopupKey] = (0, $eJOHy.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $bf7b55c097e2a19e$export$f48224de87d33a65();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const updatePopupPositionRef = (0, $eJOHy.useRef)(null);
    const canSeeRecurringWorkPopup = (projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT)) && (0, $epTsa.expVal)('jira-recur-single-work-item-on-schedule', 'showRecurringWorkPopup', false);
    const canSeeRecurringWorkPopupWithNewTrigger = canSeeRecurringWorkPopup && (0, $7jTnu.fg)('jira-recur-single-work-item-on-sched-due-date-gate');
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        if (!isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'menu',
                action: 'opened'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu', {
                userType: canManageAutomations ? 'admin' : 'endUser'
            });
        }
        if (isOpen) setActivePopupKey(null);
        setIsOpen(!isOpen);
    }, [
        canManageAutomations,
        createAnalyticsEvent,
        isOpen,
        setIsOpen
    ]); // fallback placements added as per atlaskit dropdown-menu
    const fallbackPlacements = [
        'bottom',
        'bottom-end',
        'top-start',
        'top',
        'top-end',
        'auto'
    ];
    const onClose = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
        setActivePopupKey(null);
    }, [
        setIsOpen,
        setActivePopupKey
    ]);
    const RecurWorkItemContainer = canSeeRecurringWorkPopup || canSeeRecurringWorkPopupWithNewTrigger ? (0, $6pncb.RecurWorkItemContainer) : $bf7b55c097e2a19e$var$RecurWorkItemContainerEmpty;
    (0, $eJOHy.useEffect)(()=>{
        (0, $7jTnu.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && updatePopupPositionRef.current?.();
        if (activePopupKey === (0, $9T6V5.POPUP_KEYS).recurWork) globalThis.document.querySelector(`#${(0, $9T6V5.POPUP_ID)}`)?.focus();
    }, [
        activePopupKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $4mfgo.createActionsMenuDropdownEntrypoint), $bf7b55c097e2a19e$var$entryPointParams);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            transitions: transitions,
            onSelect: onSelect,
            rules: rules,
            executeRule: executeRule,
            executingRule: executingRule,
            triggerFetch: triggerFetch,
            initialised: initialised,
            issueKey: issueKey,
            issueId: issueId,
            projectType: projectType,
            baseAutomationUrl: baseAutomationUrl,
            canManageAutomations: canManageAutomations,
            activePopupKey: activePopupKey,
            setActivePopupKey: setActivePopupKey,
            canSeeRecurringWorkPopup: canSeeRecurringWorkPopup,
            canSeeRecurringWorkPopupWithNewTrigger: canSeeRecurringWorkPopupWithNewTrigger,
            onClose: onClose
        }), [
        transitions,
        onSelect,
        rules,
        executeRule,
        executingRule,
        triggerFetch,
        initialised,
        issueKey,
        issueId,
        projectType,
        baseAutomationUrl,
        canManageAutomations,
        activePopupKey,
        setActivePopupKey,
        canSeeRecurringWorkPopup,
        canSeeRecurringWorkPopupWithNewTrigger,
        onClose
    ]);
    return /*#__PURE__*/ $eJOHy.createElement(RecurWorkItemContainer, {
        issueKey: issueKey
    }, /*#__PURE__*/ $eJOHy.createElement((0, $cNe2t.JiraPopup), {
        messageId: "issue-field-status.ui.status-view.actions.actions-menu.popup",
        messageType: "transactional",
        isOpen: isOpen,
        placement: "bottom-start",
        fallbackPlacements: fallbackPlacements,
        id: (0, $9T6V5.POPUP_ID),
        trigger: (triggerProps)=>{
            const trigger = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ $eJOHy.createElement((0, $Ay1uj.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: onTriggerClick,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dtpha))),
                isTooltipDisabled: false,
                tooltip: $bf7b55c097e2a19e$var$tooltipOptions,
                label: formatMessage((0, $jGBZo.default).automation),
                interactionName: "jira-issue-field-status.ui.status-view.actions.actions-menu.button",
                ref: (element)=>{
                    triggerRef(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }) : /*#__PURE__*/ $eJOHy.createElement((0, $goZPP.default), {
                ...triggerProps,
                appearance: "subtle",
                isSelected: isOpen,
                onClick: onTriggerClick,
                iconAfter: /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    label: "",
                    size: "small"
                }),
                iconBefore: /*#__PURE__*/ $eJOHy.createElement((0, $fL0In.default), {
                    size: "medium",
                    glyph: (0, $c3rOS.AutomationGlyph),
                    label: "",
                    secondaryColor: "none"
                }),
                interactionName: "jira-issue-field-status.ui.status-view.actions.actions-menu.button",
                ref: (element)=>{
                    triggerRef(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                }
            }, formatMessage((0, $jGBZo.default).actions));
            return trigger;
        },
        onClose: onClose,
        content: ({ update: update })=>{
            if ((0, $7jTnu.fg)('jira-recur-single-work-item-on-sched-due-date-gate')) updatePopupPositionRef.current = update;
            return /*#__PURE__*/ $eJOHy.createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "actions-menu-dropdown-entrypoint",
                packageName: "jira-actions-menu-dropdown",
                fallback: null,
                runtimeProps: runtimeProps
            });
        },
        zIndex: (0, $dPMMf.layers).modal,
        shouldRenderToParent: true,
        modifiers: $bf7b55c097e2a19e$var$customModifiers,
        testId: "issue-field-status.ui.status-view.actions.actions-menu.popup"
    }));
};

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("c3rOS", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $ca1b0bbb2612bc73$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $ca1b0bbb2612bc73$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("6pncb", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $c7179b3f6e81c7a6$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $c7179b3f6e81c7a6$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $c7179b3f6e81c7a6$export$eb9ad4e1e739768e);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

var $bNexr = parcelRequire("bNexr");

var $3MbOI = parcelRequire("3MbOI");

var $eSnSE = parcelRequire("eSnSE");

var $5Ix22 = parcelRequire("5Ix22");

var $as8tn = parcelRequire("as8tn");
const $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer = (0, $6E16M.createContainer)();
const $c7179b3f6e81c7a6$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $g1NZW.useEnvironment)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (!projectId) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $c7179b3f6e81c7a6$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $as8tn.INITIAL_STATE),
    actions: $5Ix22.actions,
    containedBy: $c7179b3f6e81c7a6$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $5Ix22.actions).fetch());
            }
    }
});
const $c7179b3f6e81c7a6$export$6630e454597fb59c = (0, $iJq0l.createHook)($c7179b3f6e81c7a6$export$390f32400eaf98c9);
const $c7179b3f6e81c7a6$export$5730c874dfb9803f = (0, $iJq0l.createStateHook)($c7179b3f6e81c7a6$export$390f32400eaf98c9);
const $c7179b3f6e81c7a6$export$eb9ad4e1e739768e = (0, $iJq0l.createActionsHook)($c7179b3f6e81c7a6$export$390f32400eaf98c9);

});
parcelRegister("3MbOI", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cea734a12424bed3$export$3901076af3749fa9);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $lvKO5 = parcelRequire("lvKO5");

var $c9f6v = parcelRequire("c9f6v");
const $cea734a12424bed3$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $4qiFT.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cea734a12424bed3$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cea734a12424bed3$var$useCurrentUserBasic();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $c9f6v.useUserSubscriber)();
    (0, $eJOHy.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cea734a12424bed3$export$3901076af3749fa9 = ()=>// eslint-disable-next-line react-hooks/react-compiler
    (0, $lvKO5.useTenantContext)().isAnonymous ? $cea734a12424bed3$var$useCurrentUserBasic() : $cea734a12424bed3$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cea734a12424bed3$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cea734a12424bed3$export$3901076af3749fa9();
    return children(result);
};

});

parcelRegister("5Ix22", function(module, exports) {

$parcel$export(module.exports, "actions", () => $13cafe401ee5ee68$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1Lz15 = parcelRequire("1Lz15");

var $2ZEsM = parcelRequire("2ZEsM");

var $b7KsF = parcelRequire("b7KsF");

var $f0czN = parcelRequire("f0czN");
const $13cafe401ee5ee68$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $13cafe401ee5ee68$export$e324594224ef24da = {
    fetch: $1Lz15.fetch,
    setIssueProperties: $13cafe401ee5ee68$export$5153917efea4a83d,
    setAsNonRecurringIssue: $2ZEsM.setAsNonRecurringIssue,
    setAsRecurringIssue: $b7KsF.setAsRecurringIssue,
    updateRule: $f0czN.updateRule
};

});
parcelRegister("1Lz15", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $k9ldc = parcelRequire("k9ldc");

var $g7LgB = parcelRequire("g7LgB");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $9Vf8k = parcelRequire("9Vf8k");
const $92eb5cf7fd76697f$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $k9ldc.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $g7LgB.RuleState).DISABLED) {
                    await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $9Vf8k.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $7jTnu.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("k9ldc", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $5469679b83f8a32d$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $5469679b83f8a32d$export$3cada9835f092161);

var $jbPE2 = parcelRequire("jbPE2");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");
const $5469679b83f8a32d$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $jGzN3.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $1uIew.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $5469679b83f8a32d$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $jGzN3.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $1uIew.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});

parcelRegister("g7LgB", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $fc4f058c04244dcc$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $fc4f058c04244dcc$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $fc4f058c04244dcc$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $fc4f058c04244dcc$export$c07ca23c166d6344);
const $fc4f058c04244dcc$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $fc4f058c04244dcc$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $fc4f058c04244dcc$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $fc4f058c04244dcc$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $fc4f058c04244dcc$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("f3jI4", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $e4bbd2fe0788cecd$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $e4bbd2fe0788cecd$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a);

var $jbPE2 = parcelRequire("jbPE2");

var $jGzN3 = parcelRequire("jGzN3");
const $e4bbd2fe0788cecd$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $jGzN3.performDeleteRequest)(DELETE_RULE_URL);
};
const $e4bbd2fe0788cecd$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $jGzN3.performDeleteRequest)(ruleConfigEndpoint);
};
const $e4bbd2fe0788cecd$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $jGzN3.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("9riZR", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $6b2665faae66cf06$export$7ad2acdaf7d8c23c);

var $1uIew = parcelRequire("1uIew");

var $gCeeo = parcelRequire("gCeeo");
const $6b2665faae66cf06$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $1uIew.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $6b2665faae66cf06$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$6b2665faae66cf06$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("9Vf8k", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $aefb7d8338ffa0c9$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $aefb7d8338ffa0c9$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $aefb7d8338ffa0c9$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $aefb7d8338ffa0c9$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $aefb7d8338ffa0c9$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $aefb7d8338ffa0c9$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $aefb7d8338ffa0c9$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $aefb7d8338ffa0c9$export$555109634e8a63b6);

var $cSmYj = parcelRequire("cSmYj");

var $5IPrF = parcelRequire("5IPrF");

var $8RQlO = parcelRequire("8RQlO");

var $e3Aqb = parcelRequire("e3Aqb");

var $fBF7C = parcelRequire("fBF7C");
var $h5cuQ = parcelRequire("h5cuQ");

var $9RPB3 = parcelRequire("9RPB3");

var $b5IjV = parcelRequire("b5IjV");
const $aefb7d8338ffa0c9$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9RPB3.Frequencies).DAILY,
                byDay: [
                    (0, $9RPB3.Days).MO,
                    (0, $9RPB3.Days).TU,
                    (0, $9RPB3.Days).WE,
                    (0, $9RPB3.Days).TH,
                    (0, $9RPB3.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9RPB3.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $aefb7d8338ffa0c9$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9RPB3.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(rrule.byDay, [
            (0, $9RPB3.Days).MO,
            (0, $9RPB3.Days).TU,
            (0, $9RPB3.Days).WE,
            (0, $9RPB3.Days).TH,
            (0, $9RPB3.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9RPB3.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $aefb7d8338ffa0c9$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $b5IjV.default).recursOnComplete;
    const frequency = $aefb7d8338ffa0c9$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $b5IjV.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $b5IjV.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $b5IjV.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $b5IjV.default).recursWeekly;
    return (0, $b5IjV.default).setToRecur;
};
const $aefb7d8338ffa0c9$var$byDayOptions = Object.values((0, $9RPB3.Days));
const $aefb7d8338ffa0c9$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $aefb7d8338ffa0c9$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$aefb7d8338ffa0c9$var$byDayOptions}`);
    const firstDayOfWeek = (0, $5IPrF.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $8RQlO.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $aefb7d8338ffa0c9$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$aefb7d8338ffa0c9$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $aefb7d8338ffa0c9$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $b5IjV.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $b5IjV.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $aefb7d8338ffa0c9$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $aefb7d8338ffa0c9$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $aefb7d8338ffa0c9$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $aefb7d8338ffa0c9$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $aefb7d8338ffa0c9$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$aefb7d8338ffa0c9$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$aefb7d8338ffa0c9$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $aefb7d8338ffa0c9$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $e3Aqb.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $e3Aqb.default)(userTimezone);
    return (0, $fBF7C.default)((0, $h5cuQ.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9RPB3", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $0c0ab4669e06d62e$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $0c0ab4669e06d62e$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $0c0ab4669e06d62e$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $0c0ab4669e06d62e$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $0c0ab4669e06d62e$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $0c0ab4669e06d62e$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $0c0ab4669e06d62e$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $0c0ab4669e06d62e$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $0c0ab4669e06d62e$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $0c0ab4669e06d62e$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $0c0ab4669e06d62e$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $0c0ab4669e06d62e$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $0c0ab4669e06d62e$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $0c0ab4669e06d62e$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $0c0ab4669e06d62e$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $0c0ab4669e06d62e$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $0c0ab4669e06d62e$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $0c0ab4669e06d62e$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $0c0ab4669e06d62e$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $0c0ab4669e06d62e$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $0c0ab4669e06d62e$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $0c0ab4669e06d62e$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $0c0ab4669e06d62e$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $0c0ab4669e06d62e$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $0c0ab4669e06d62e$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $0c0ab4669e06d62e$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $0c0ab4669e06d62e$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $0c0ab4669e06d62e$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $0c0ab4669e06d62e$export$f3abe3d006c81602);
const $0c0ab4669e06d62e$export$665ca7211e0c33c = /\r?\n/;
const $0c0ab4669e06d62e$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $0c0ab4669e06d62e$export$ae9ea0d00d3d8982 = 'CRLF';
const $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a = '\r\n';
const $0c0ab4669e06d62e$export$606cfc2a8896c91f = 'LF';
const $0c0ab4669e06d62e$export$477fea8aa280bb1e = '\n';
const $0c0ab4669e06d62e$export$ccae594c20078277 = {
    CRLF: $0c0ab4669e06d62e$export$ae9ea0d00d3d8982,
    LF: $0c0ab4669e06d62e$export$606cfc2a8896c91f
};
const $0c0ab4669e06d62e$export$c3edd2b21ac02f88 = {
    [$0c0ab4669e06d62e$export$ae9ea0d00d3d8982]: $0c0ab4669e06d62e$export$a1f3f1ef020bdc3a,
    [$0c0ab4669e06d62e$export$606cfc2a8896c91f]: $0c0ab4669e06d62e$export$477fea8aa280bb1e
};
const $0c0ab4669e06d62e$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $0c0ab4669e06d62e$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $0c0ab4669e06d62e$export$f62540a8bebc4ed3 = 'BEGIN';
const $0c0ab4669e06d62e$export$32239d68d9c6cb49 = 'END';
const $0c0ab4669e06d62e$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $0c0ab4669e06d62e$export$987d86d2e891c4cb = 'END:VEVENT';
const $0c0ab4669e06d62e$export$fd1a0e011a586e26 = 'DTSTART';
const $0c0ab4669e06d62e$export$d86ed937a45b0291 = 'RRULE';
const $0c0ab4669e06d62e$export$913055729e1380b2 = 'SUMMARY';
const $0c0ab4669e06d62e$export$87d0ca22edb7493a = 'LOCATION';
const $0c0ab4669e06d62e$export$d44826c816b5619b = 'DESCRIPTION';
const $0c0ab4669e06d62e$export$c8b4a4d253b84ce0 = 'UID';
const $0c0ab4669e06d62e$export$34694f8d8b23ee2a = 'SEQUENCE';
const $0c0ab4669e06d62e$export$e50006273435e7d4 = 'STATUS';
const $0c0ab4669e06d62e$export$36034111438e3f25 = 'TRANSP';
const $0c0ab4669e06d62e$export$bb34f3538ba26c7e = 'PRIORITY';
const $0c0ab4669e06d62e$export$30dbcad954808285 = 'DTEND';
const $0c0ab4669e06d62e$export$bacc88974c736870 = 'DURATION';
const $0c0ab4669e06d62e$export$da3a32b38cbf59ba = 'ATTACH';
const $0c0ab4669e06d62e$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $0c0ab4669e06d62e$export$a513ea61a7bee91c = 'CATEGORIES';
const $0c0ab4669e06d62e$export$a29989082612d0d9 = 'COMMENT';
const $0c0ab4669e06d62e$export$11038cc09fdccb91 = 'CONTACT';
const $0c0ab4669e06d62e$export$133ffe3c8efbf133 = 'EXDATE';
const $0c0ab4669e06d62e$export$7e27a94778a9d7d7 = 'EXRULE';
const $0c0ab4669e06d62e$export$3d166b1dacd2503a = 'RDATE';
const $0c0ab4669e06d62e$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $0c0ab4669e06d62e$export$4e841128923ef26 = 'RESOURCES';
const $0c0ab4669e06d62e$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $0c0ab4669e06d62e$export$61abde59b50deb8e = 'URL';
const $0c0ab4669e06d62e$export$ff39ebd4bb12b718 = 'CREATED';
const $0c0ab4669e06d62e$export$2ebcefe61501d5fe = 'DTSTAMP';
const $0c0ab4669e06d62e$export$90812500f628da64 = 'LAST-MODIFIED';
const $0c0ab4669e06d62e$export$5409f4c14bda7ac = 'ORGANIZER';
const $0c0ab4669e06d62e$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $0c0ab4669e06d62e$export$98eba4d8ff00c139 = {
    BEGIN: $0c0ab4669e06d62e$export$f62540a8bebc4ed3,
    END: $0c0ab4669e06d62e$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $0c0ab4669e06d62e$export$67de00e87412dc6f,
    END_VEVENT: $0c0ab4669e06d62e$export$987d86d2e891c4cb,
    SUMMARY: $0c0ab4669e06d62e$export$913055729e1380b2,
    LOCATION: $0c0ab4669e06d62e$export$87d0ca22edb7493a,
    DESCRIPTION: $0c0ab4669e06d62e$export$d44826c816b5619b,
    UID: $0c0ab4669e06d62e$export$c8b4a4d253b84ce0,
    SEQUENCE: $0c0ab4669e06d62e$export$34694f8d8b23ee2a,
    STATUS: $0c0ab4669e06d62e$export$e50006273435e7d4,
    TRANSP: $0c0ab4669e06d62e$export$36034111438e3f25,
    PRIORITY: $0c0ab4669e06d62e$export$bb34f3538ba26c7e,
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291,
    DTEND: $0c0ab4669e06d62e$export$30dbcad954808285,
    DURATION: $0c0ab4669e06d62e$export$bacc88974c736870,
    ATTACH: $0c0ab4669e06d62e$export$da3a32b38cbf59ba,
    ATTENDEE: $0c0ab4669e06d62e$export$5e0bdf8bba8d5088,
    CATEGORIES: $0c0ab4669e06d62e$export$a513ea61a7bee91c,
    COMMENT: $0c0ab4669e06d62e$export$a29989082612d0d9,
    CONTACT: $0c0ab4669e06d62e$export$11038cc09fdccb91,
    EXDATE: $0c0ab4669e06d62e$export$133ffe3c8efbf133,
    EXRULE: $0c0ab4669e06d62e$export$7e27a94778a9d7d7,
    RDATE: $0c0ab4669e06d62e$export$3d166b1dacd2503a,
    RELATED_TO: $0c0ab4669e06d62e$export$47a1d4cd38dddc05,
    RESOURCES: $0c0ab4669e06d62e$export$4e841128923ef26,
    RECURRENCE_ID: $0c0ab4669e06d62e$export$1c0dd28c42f2741e,
    URL: $0c0ab4669e06d62e$export$61abde59b50deb8e,
    CREATED: $0c0ab4669e06d62e$export$ff39ebd4bb12b718,
    DTSTAMP: $0c0ab4669e06d62e$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $0c0ab4669e06d62e$export$90812500f628da64,
    ORGANIZER: $0c0ab4669e06d62e$export$5409f4c14bda7ac,
    REQUEST_STATUS: $0c0ab4669e06d62e$export$9fe99b3b71be9378
};
const $0c0ab4669e06d62e$export$38b1323f325ffd22 = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    RRULE: $0c0ab4669e06d62e$export$d86ed937a45b0291
};
const $0c0ab4669e06d62e$export$5b9a78912028c06d = 'TZID';
const $0c0ab4669e06d62e$export$20184b745430719e = {
    DTSTART: $0c0ab4669e06d62e$export$fd1a0e011a586e26,
    TZID: $0c0ab4669e06d62e$export$5b9a78912028c06d
};
const $0c0ab4669e06d62e$export$fb124b4fa837b262 = 'FREQ';
const $0c0ab4669e06d62e$export$4cc4f35131ed029c = 'UNTIL';
const $0c0ab4669e06d62e$export$7dea0e6e08f87a8a = 'INTERVAL';
const $0c0ab4669e06d62e$export$a764ed9c4884f76d = 'BYHOUR';
const $0c0ab4669e06d62e$export$7a96578de7a037b6 = 'BYMINUTE';
const $0c0ab4669e06d62e$export$55bcca3bd8d3041f = 'BYSECOND';
const $0c0ab4669e06d62e$export$f512ea3e90612d03 = 'BYDAY';
const $0c0ab4669e06d62e$export$b3203f635d74ce88 = 'BYMONTH';
const $0c0ab4669e06d62e$export$15623ad945e92c4c = 'BYMONTHDAY';
const $0c0ab4669e06d62e$export$7898bd020dba0a27 = {
    FREQ: $0c0ab4669e06d62e$export$fb124b4fa837b262,
    UNTIL: $0c0ab4669e06d62e$export$4cc4f35131ed029c,
    INTERVAL: $0c0ab4669e06d62e$export$7dea0e6e08f87a8a,
    BYHOUR: $0c0ab4669e06d62e$export$a764ed9c4884f76d,
    BYMINUTE: $0c0ab4669e06d62e$export$7a96578de7a037b6,
    BYSECOND: $0c0ab4669e06d62e$export$55bcca3bd8d3041f,
    BYDAY: $0c0ab4669e06d62e$export$f512ea3e90612d03,
    BYMONTH: $0c0ab4669e06d62e$export$b3203f635d74ce88,
    BYMONTHDAY: $0c0ab4669e06d62e$export$15623ad945e92c4c
};
const $0c0ab4669e06d62e$export$64c81710c321f252 = 'MISSING';
const $0c0ab4669e06d62e$export$ccb33e29d92c9a58 = 'EMPTY';
const $0c0ab4669e06d62e$export$9a105a556e65c2c0 = 'INVALID';
const $0c0ab4669e06d62e$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("b5IjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $129c4b3b6b9310c5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $129c4b3b6b9310c5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("2ZEsM", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $215cf24c960383d9$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gCeeo = parcelRequire("gCeeo");

var $as8tn = parcelRequire("as8tn");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");
const $215cf24c960383d9$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $f3jI4.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $as8tn.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("as8tn", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $924bedb187db69de$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $924bedb187db69de$export$a1b15f9b9ceb0f70);
const $924bedb187db69de$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $924bedb187db69de$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("b7KsF", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $480578f2ddd18139$export$5d9cc8e9f9314f21);

var $aXKmr = parcelRequire("aXKmr");

var $gCeeo = parcelRequire("gCeeo");

var $bPEVb = parcelRequire("bPEVb");

var $g7LgB = parcelRequire("g7LgB");

var $9riZR = parcelRequire("9riZR");
const $480578f2ddd18139$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $aXKmr.v4)();
        const templateId = (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $9riZR.callServiceWithAnalytics)(analyticsEvent, (0, $bPEVb.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("bPEVb", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $688cd7c66c97ef2e$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $688cd7c66c97ef2e$export$5153917efea4a83d);

var $3osLr = parcelRequire("3osLr");

var $jbPE2 = parcelRequire("jbPE2");

var $jGzN3 = parcelRequire("jGzN3");

var $g7LgB = parcelRequire("g7LgB");
const $688cd7c66c97ef2e$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $jbPE2.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $g7LgB.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $jGzN3.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $688cd7c66c97ef2e$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $jGzN3.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("f0czN", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $d769bcc7f9751998$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gCeeo = parcelRequire("gCeeo");

var $f3jI4 = parcelRequire("f3jI4");

var $9riZR = parcelRequire("9riZR");

var $b7KsF = parcelRequire("b7KsF");

var $2ZEsM = parcelRequire("2ZEsM");
const $d769bcc7f9751998$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $2ZEsM.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $b7KsF.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $9riZR.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $f3jI4.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("jGBZo", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e22d2800c16ca2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $01e22d2800c16ca2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    automation: {
        "id": "issue-field-status.status-view.actions.actions-menu.automation",
        "defaultMessage": "Automation"
    },
    actions: {
        "id": "issue-field-status.status-view.actions.actions-menu.actions",
        "defaultMessage": "Actions"
    },
    manualRules: {
        "id": "issue-field-status.status-view.actions.actions-menu.manual-rules",
        "defaultMessage": "From Automation"
    },
    workflowTransitions: {
        "id": "issue-field-status.status-view.actions.actions-menu.workflow-transitions",
        "defaultMessage": "From Workflow"
    }
});

});

parcelRegister("9T6V5", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $0807d9425ee3dd3b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "POPUP_ID", () => $0807d9425ee3dd3b$export$15a8d6e972bbb4b3);
$parcel$export(module.exports, "RECUR_WORK_COMPONENT_TEST_ID_PREFIX", () => $0807d9425ee3dd3b$export$3e363f319e1afe5e);
$parcel$export(module.exports, "POPUP_KEYS", () => $0807d9425ee3dd3b$export$d41dc11f8bf913b8);
const $0807d9425ee3dd3b$export$b8b9d90f9e5bd72b = 'jira-issue-field-status';
const $0807d9425ee3dd3b$export$15a8d6e972bbb4b3 = 'issue-field-status-view-actions-menu-popup';
const $0807d9425ee3dd3b$export$3e363f319e1afe5e = 'issue-field-status.ui.status-view.actions.actions-menu';
const $0807d9425ee3dd3b$export$d41dc11f8bf913b8 = {
    recurWork: 'RECUR_WORK'
};

});

parcelRegister("4mfgo", function(module, exports) {

$parcel$export(module.exports, "createActionsMenuDropdownEntrypoint", () => $e1edb0b7853c290b$export$4b52670deab00a4c);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $e1edb0b7853c290b$export$4b52670deab00a4c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dWCVz")), {
        moduleId: "61cf8fbf",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dWCVz", function(module, exports) {

let $a26ee352e541bf97$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a26ee352e541bf97$var$load("ffQaD"),
    $a26ee352e541bf97$var$load("kvRbA"),
    $a26ee352e541bf97$var$load("jGNRK")
]).then(()=>parcelRequire('al5Bx'));

});





$parcel$global.rlb("jteQo")
//# sourceMappingURL=actions-new.4eeadb3c.js.map
